// mobile menu click open/close handler
const clickOutsideMenu = function (event) {
  if (
    $(event.target).closest("#main-nav").length === 1 ||
    $(event.target).closest("#menu_open").length === 1
  )
    return;
  $("#main-nav").removeClass("display");
  $("#menu_open").removeClass("active");
  $("body").off("click", clickOutsideMenu);
};

$(function () {
  $(".header-title").after(" <a id='menu_open'></a> ");
  $("#menu_open").click(function () {
    $("#main-nav").toggleClass("display");
    $(this).toggleClass("active");
    $("body").click(clickOutsideMenu);
  });
});

// new request form handler
$('button[data-type="form-modal"]').click(function () {
  $("#form form").css("display", "inline-block");
  $("#form .clearfix").css("display", "block");

  _this = $(this);

  var goal = "ORDERCALL";
  var ga = "";
  switch ($(this).data("format")) {
    case "record":
      $("#form .teacher").html("");
      ga = "ga('send', 'event', 'order', 'firstlesson');";
    case "interactive-price":
      goal = $(this).data("format") === "record" ? "OrderSchool" : "OrderCurs";
      var html = "Вы можете записаться в душевный клуб";

      html +=
        '<br><span style="color:#173E69;">(пробное посещение по супер-цене)</span>';

      html += ", заполнив приведенную ниже форму, и мы с вами свяжемся.";

      $("#form .descr").html(html);

      if (goal == "OrderCurs") {
        ga = "ga('send', 'event', 'order', 'curs');";
      }
      break;
    case "question":
      $("#form .descr").html("");
      break;
    case "teacher":
      goal = "OrderLect";
      $("#form .descr").html("");
      break;
    case "record-to-teacher":
      goal = "OrderSchool";
      $("#form .descr").html("");
      break;
  }
  if (typeof $(this).attr("data-yacounter") != "undefined") {
    $("form button").attr(
      "onclick",
      (typeof window.yaCounter99479385 === "function"
        ? `yaCounter99479385().reachGoal(${goal});`
        : "") +
        (typeof window.ga === "function" ? ga : "") +
        " return true;"
    );
  } else {
    $("form button").removeAttr("onclick");
  }
  $("#form .title").html($(this).data("title"));
  if ($(this).data("theme")) {
    $("#form input[name=theme]").val($(this).data("theme"));
  } else {
    $("#form input[name=theme]").val($(this).data("title"));
  }
  $("#form input[name=format]").val($(this).data("format"));
  $('#form input[type="text"]').each(function () {
    if (typeof _this.data("value-" + $(this).attr("name")) != "undefined") {
      $(this).val(_this.data("value-" + $(this).attr("name")));
    } else if (
      $(this).attr("value") != "" &&
      $(this).attr("value") != undefined
    ) {
      return true;
    } else {
      $(this).val("");
    }
  });
  $("#form .console").html("");
  $("#form").removeClass("timeout-close");
  $("#form").arcticmodal();
  return false;
});

$('a[href^="#"]').click(function () {
  var target = $(this).attr("href");
  $("html, body").animate({ scrollTop: $(target).offset().top }, 300);
  return false;
});

// new request form handler
$("#form form").submit(function () {
  var allData = $(this).serialize();
  var console = $("#form .console");
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  if (typeof toid != "undefined") {
    clearTimeout(toid);
  }
  console.html("Отправка...");
  $.ajax({
    url: "/create_lesson_request",
    headers: { "X-CSRF-Token": token },
    data: allData,
    type: "POST",
    dataType: "json",
  })
    .done(function (result) {
      if (result.message) {
        console.html(result.message);
      } else {
        var t = 5;
        func = function () {
          if (!$("#form").hasClass("timeout-close")) return false;
          if (t > 0) toid = setTimeout(func, 1000);
          else {
            $("#form .box-modal_close").click();
            return;
          }
          $("#form .console").html("Заявка отправлена(" + t + ")");
          t--;
        };
        $("#form").addClass("timeout-close");
        func();
      }
    })
    .fail(function () {
      $("#form .console").html("Ошибка... лучше позвоните");
    });
  return false;
});

$("#courses article").hover(
  function () {
    $(this).stop().addClass("hover");
  },
  function () {
    $(this).removeClass("hover");
  }
);

$(".achive .more span").click(function () {
  $(this).hide().parent(".more").next("div").slideDown("fast");
});

$(document).ready(function () {
  $("#carusel-teachers .bxslider").bxSlider({
    minSlides: 1,
    maxSlides: 6,
    slideWidth: 156,
    slideMargin: 0,
    pager: false,
    infiniteLoop: false,
    moveSlides: 1,
  });
});

// click by course name should filter teachers by clicked course
$("nav.list li").click(function (event) {
  if (typeof $(this).data("url") != "undefined" && $(this).data("url") != "") {
    window.location.href = $(this).data("url");
    return false;
  }
  if ($(this).parents("#contact").length > 0) return;
  var thisGroup = $(this).data("group");
  // var thisTime = $(this).data("time");
  var allList = $(this).parents("nav").next(".group").children("article");
  if ($(this).closest("#cat-school").length) {
    $(".teacher-cat-desc").hide();
    $(".teacher-cat-desc-default").show();
  }
  if (thisGroup) {
    switch (thisGroup) {
      case "all":
        allList.show();
        break;
      default:
        allList.each(function (_, el) {
          if ($(el).data("group").indexOf(thisGroup) >= 0) {
            $(el).show();
          } else {
            $(el).hide();
          }
        });
    }
  } else {
    // var now = new Date();
    // switch (thisTime) {
    //   case "all":
    //     allList.show();
    //     break;
    //   case "week":
    //     var CurrentDay = now.getDay();
    //     var RightOffset = 7 - CurrentDay;
    //     var Last = new Date(
    //       now.getFullYear(),
    //       now.getMonth(),
    //       now.getDate() + RightOffset + 1
    //     );
    //     Last = Last.valueOf();
    //     allList.each(function (index, el) {
    //       var eventDate = parseInt($(el).data("time")) * 1000;
    //       if (eventDate < Last) {
    //         $(el).show();
    //       } else {
    //         $(el).hide();
    //       }
    //     });
    //     break;
    //   case "month":
    //     var endMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    //     endMonth = endMonth.valueOf();
    //     allList.each(function (index, el) {
    //       var eventDate = parseInt($(el).data("time")) * 1000;
    //       if (eventDate < endMonth) {
    //         $(el).show();
    //       } else {
    //         $(el).hide();
    //       }
    //     });
    // }
  }
  $(this).addClass("active").siblings("li.active").removeClass("active");
});

// click by teacher card
// $("#teachers section.group a").click(function () {
//   url = $(this).attr("href");
//   type = $(this).closest("section.group").attr("data-type");
//   group = $('#teachers nav[data-type="' + type + '"]')
//     .find("li.active")
//     .attr("data-group");
//   redirect_url = url + "?&type=" + type + "&group=" + group;
//   $.cookie("tchr_type", type);
//   $.cookie("tchr_group", group);
//   window.location.href = redirect_url;
//   return false;
// });

$(document).ready(function ($) {
  $(".fancy-main-gallery").fancybox({
    openEffect: "none",
    closeEffect: "none",
    helpers: { media: {} },
  });
  // if ($("#teachers").length) {
  //   tchr_type = $.cookie("tchr_type");
  //   tchr_group = $.cookie("tchr_group");
  //   if (tchr_type != null && tchr_group != null) {
  //     $(
  //       '#teachers nav[data-type="' +
  //         tchr_type +
  //         '"] li[data-group="' +
  //         tchr_group +
  //         '"]'
  //     ).click();
  //     $.cookie("tchr_type", null);
  //     $.cookie("tchr_group", null);
  //     $("html, body")
  //       .stop()
  //       .animate(
  //         {
  //           scrollTop: $(
  //             '#teachers nav[data-type="' + tchr_type + '"]'
  //           ).offset().top,
  //         },
  //         1000
  //       );
  //   }
  // }
});

$("#slider .play").click(function (event) {
  $this = $(this);
  $("#video-wrap")
    .html($(this).data("video"))
    .fadeIn("slow", function () {
      $("#slider").css("background", "none");
      $this.fadeOut("slow");
    });
});

// yaMap settings
var init = function () {
  var myMap = new ymaps.Map("map", {
    center: [83.77976, 53.331565],
    zoom: 20,
    controls: ["smallMapDefaultSet"],
  });
  myMap.behaviors.disable("scrollZoom");

  var mapConfig = { type: "FeatureCollection", features: [] };
  const $cityPlace = $(".city-place");
  var thisPlace = {
    type: "Feature",
    geometry: { type: "Point", coordinates: [] },
    properties: {},
    options: { preset: "islands#blueIcon" },
  };
  var coordinates = $cityPlace.data("coordinates").split(",");
  thisPlace.geometry.coordinates = [
    parseFloat(coordinates[0]),
    parseFloat(coordinates[1]),
  ];
  thisPlace.properties.hintContent = $cityPlace.find(".title").text();
  // thisPlace.properties.iconContent = $cityPlace.find(".number").text();
  mapConfig.features.push(thisPlace);

  ymaps.geoQuery(mapConfig).addTo(myMap.geoObjects).applyBoundsToMap(myMap, {
    checkZoomRange: true,
    zoomMargin: 20,
  });
};

try {
  ymaps.ready(init);
} catch (e) {}
